import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Organizations } from '../model/organization.model';

const baseUrl = `/api/organizations`;

@Injectable({
    providedIn: 'root',
})
export class OrganizationClient {
    private _httpClient = inject(HttpClient);

    list() {
        return this._httpClient.get<Organizations>(`${baseUrl}`);
    }
}
